export class UserLogin {
    public username = '';
    public password = '';
    public refresh_token = '';
}
